import React, { PropTypes } from 'react';
import TextField from 'material-ui/TextField';

class TwoColumnsContetnSimpleCell extends React.Component {
  static propTypes = {
    cell: PropTypes.object,
    onUpdate: PropTypes.func.isRequired
  };

  render() {
    let { cell, onUpdate } = this.props;

    return (
      <TextField name="label" value={cell.primaryText} onChange={(event) => onUpdate(event.target.value)}/>
    );
  }
}

export default TwoColumnsContetnSimpleCell;




// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/TwoColumnContent/TwoColumnsContetnSimpleCell.js